
import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged, fromEvent, map, merge, Subject } from "rxjs";
import { NetworkStatus } from "../../models/agent.model";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class OfflineService {

    private networkStatus$= new BehaviorSubject<NetworkStatus>(
         navigator.onLine ? NetworkStatus.ONLINE : NetworkStatus.OFFLINE);


    public readonly status$ = this.networkStatus$.asObservable();

    // `distinctUntilChanged` : n'émet que sur un VRAI changement offline↔online.
    // Sans lui, chaque ping ré-émettait la même valeur et faisait re-tourner
    // toutes les souscriptions réseau (jusqu'à la cascade infinie de health-checks).
    public readonly isOnline$ = this.status$.pipe(
        map(status => status === NetworkStatus.ONLINE),
        distinctUntilChanged()
    );

    // Battement périodique de synchronisation : émis à chaque ping périodique
    // réussi tant qu'on est en ligne. Sert à REJOUER le vidage des files
    // (retry borné à 1×/intervalle) sans dépendre d'une transition réseau.
    private syncTickSource = new Subject<void>();
    public readonly syncTick$ = this.syncTickSource.asObservable();

    constructor() {
      this.initNetworkCheckers();
    }

    private initNetworkCheckers() {
        const online$ = fromEvent(window, 'online').pipe(map(() => NetworkStatus.ONLINE));
        const offline$ = fromEvent(window, 'offline').pipe(map(() => NetworkStatus.OFFLINE));

        merge(online$, offline$)
        .pipe(distinctUntilChanged())
        .subscribe(status => {
            console.log(`offline serviceNetwork status changed ${status}`);
            this.networkStatus$.next(status)
        });

        // Ping périodique de secours (les événements navigateur online/offline
        // restent immédiats). Toutes les 2 minutes pour éviter de marteler le serveur.
        // Après chaque ping réussi en ligne, on émet un « battement » de synchro
        // pour permettre aux files locales de rejouer un envoi échoué.
        setInterval(async () => {
           console.log('offline service checking network status');
           await this.pingServerHealth();
           if (this.isOnline) this.syncTickSource.next();
        }, 120000);
    }

    private async pingServerHealth() {
        try {
            const response = await fetch(environment.apiUrl + '/actuator/health', { 
                method: 'GET',
                cache: 'no-cache'
                 });
                 console.log('offline service server health check response', response);
            if (response.ok) {
                console.log('online service server is healthy');
                this.networkStatus$.next(NetworkStatus.ONLINE);
            } else {
                console.warn('offline service server health check failed');
                this.networkStatus$.next(NetworkStatus.OFFLINE);
            }
        } catch (error) {
            console.error('offline service error occurred while checking server health');
            this.networkStatus$.next(NetworkStatus.OFFLINE);
        }
    }
    get isOnline() {
        return this.networkStatus$.value === NetworkStatus.ONLINE;
    }
    get currentStatus() {
        return this.networkStatus$.value;
    }

    async checkConnectivity():Promise<boolean> {
        
        await this.pingServerHealth();
        return this.isOnline;
    }
   

}